import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Proctor from "../Pages/Proctor";
import Mobile from "../Pages/Mobile";
import Webcam from "../Pages/Webcams";
import FAQ from "../Pages/FAQ";
import WebcamTesterPage from "../Pages/WebcamTesterPage";
import SammyCamUsers from "../Pages/SammyCamUsers";
import Demo from "../Pages/Demo";
import DemoRoom from "../Pages/DemoRoom";
import Practice from "../Pages/Practice";
import SCForm from "../Pages/SCForm";
import ExamCodes from "../Pages/ExamCodes";
import GoogleRooms from "../Pages/GoogleRooms";
import Invigil from "../Pages/Invigil";
import PaymentValidation from "../Pages/PaymentValidation";
import Chat from "../Pages/Chat";
import AddClient from "../Pages/AddClient";
import CmsScheduling from "../Pages/CmsScheduling";
import CmsEntryPoint from "../Pages/CmsEntryPoint";
import CmsSession from "../Pages/CmsSession";
import Dashboard from "../Pages/Dashboard";
import Sessions from "../Pages/Sessions";
import Components from "../Components/Components";
import TwilioSC from "../Pages/TwilioSC";
import TwilioSCViewer from "../Pages/TwilioSCViewer";
import TwilioSCLinks from "../Pages/TwilioSCLinks";
import TwilioUsers from "../Pages/TwilioUsers";
import TwilioMobile from "../Pages/TwilioMobile";
import NewTesterHome from "../Pages/NewTesterHome";
import ProlydianChat from "../Pages/ProlydianChat";
import ProlydianIntegration from "../Pages/ProlydianIntegration";
import Crane from "../Pages/Crane";
import AAAFoodHandlers from "../Pages/AAAFoodHandlers";
import GoogleRoomIntegration from "../Pages/GoogleRoomIntegration";
import Pay from "../Pages/Pay";
import PaymentConfirmation from "../Pages/PaymentConfirmation";
import BackupQueue from "../Pages/BackupQueue";
import ProctorBackupQueue from "../Pages/ProctorBackupQueue";
import Tal from "../Pages/Tal";
import DemoCaveonScheduling from "../Pages/DemoCaveonScheduling";
import DemoCaveonLinks from "../Pages/DemoCaveonLinks";
import Extension from "../Pages/Extension";
import ExtensionSession from "../Pages/ExtensionSession";
import LCtest from "../Pages/LCtest";
import NewAOAScheduling from "../Pages/NewAOAScheduling";
import { Auth } from "aws-amplify";
import PodSession from "../Pages/PodSession";
import Pod from "../Pages/Pod";
import PodQueue from "../Pages/PodQueue";
import PodSessionv2 from "../Pages/PodSessionv2";
import ProctorProfile from "../Pages/ProctorProfile/ProctorProfile";
import SessionHistory from "../Pages/ProctorProfile/SessionHistory";

// create a protected route component that checks if a user is signed in and reirects to /proctor if not
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("user")) {
      setIsAuthenticated(true);
      setLoaded(true);
    } else {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          setIsAuthenticated(true);
          setLoaded(true);
        })
        .catch(() => {
          setIsAuthenticated(false);
          setLoaded(true);
        });
    }
  }, []);

  if (loaded) {
    return isAuthenticated ? children : <Navigate to="/proctor" />;
  }
};

function Nav() {
  return (
    <Routes>
      <Route index element={<NewTesterHome />} />
      <Route path="/proctor" element={<Proctor />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/sc" element={<WebcamTesterPage />} />
      <Route path="/demo-room" element={<DemoRoom />} />
      <Route path="/practice" element={<Practice />} />
      <Route path="/cms-scheduling" element={<CmsScheduling />} />
      <Route path="/cms-entry-point" element={<CmsEntryPoint />} />
      <Route path="/cms" element={<CmsSession />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/AddClient" element={<AddClient />} />
      <Route path="/components" element={<Components />} />
      <Route path="/tsc" element={<TwilioSC />} />
      <Route path="/chat-prolydian" element={<ProlydianChat />} />
      <Route path="/aoa-scheduling" element={<NewAOAScheduling />} />
      <Route path="/pay/:productId" element={<Pay />} />
      <Route path="/demoscheduling" element={<DemoCaveonScheduling />} />

      <Route
        path="/paymentconfirmation/:id"
        element={<PaymentConfirmation />}
      />
      <Route path="/waitingroom" element={<BackupQueue />} />
      <Route path="/waitingroom/:id" element={<BackupQueue />} />
      <Route
        path="/pod-session"
        element={
          <ProtectedRoute>
            <PodSession />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pod"
        element={
          <ProtectedRoute>
            <Pod />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pod-queue"
        element={
          <ProtectedRoute>
            <PodQueue />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pod-session-v2"
        element={
          <ProtectedRoute>
            <PodSessionv2 />
          </ProtectedRoute>
        }
      />
      <Route
        path="/extension"
        element={
          <ProtectedRoute>
            <Extension />
          </ProtectedRoute>
        }
      />
      <Route
        path="/extension/:id"
        element={
          <ProtectedRoute>
            <ExtensionSession />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lctest"
        element={
          <ProtectedRoute>
            <LCtest />
          </ProtectedRoute>
        }
      />
      <Route
        path="/demolinks"
        element={
          <ProtectedRoute>
            <DemoCaveonLinks />
          </ProtectedRoute>
        }
      />
      <Route
        path="/proctorbackupqueue"
        element={
          <ProtectedRoute>
            <ProctorBackupQueue />
          </ProtectedRoute>
        }
      />
      <Route
        path="/twiliosc"
        element={
          <ProtectedRoute>
            <TwilioSCViewer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/twiliolinks"
        element={
          <ProtectedRoute>
            <TwilioSCLinks />
          </ProtectedRoute>
        }
      />
      <Route
        path="/twiliousers"
        element={
          <ProtectedRoute>
            <TwilioUsers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/mobile"
        element={
          <ProtectedRoute>
            <Mobile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/webcams"
        element={
          <ProtectedRoute>
            <Webcam />
          </ProtectedRoute>
        }
      />
      <Route
        path="/webcam-form"
        element={
          <ProtectedRoute>
            <SCForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/webcam-users"
        element={
          <ProtectedRoute>
            <SammyCamUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/invigil"
        element={
          <ProtectedRoute>
            <Invigil />
          </ProtectedRoute>
        }
      />
      <Route
        path="/google-rooms"
        element={
          <ProtectedRoute>
            <GoogleRooms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/codes"
        element={
          <ProtectedRoute>
            <ExamCodes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment-validation"
        element={
          <ProtectedRoute>
            <PaymentValidation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions"
        element={
          <ProtectedRoute>
            <Sessions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/twmobile"
        element={
          <ProtectedRoute>
            <TwilioMobile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/prolydian-integration"
        element={
          <ProtectedRoute>
            <ProlydianIntegration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crane"
        element={
          <ProtectedRoute>
            <Crane />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tal"
        element={
          <ProtectedRoute>
            <Tal />
          </ProtectedRoute>
        }
      />
      <Route
        path="/aaa-food-handlers"
        element={
          <ProtectedRoute>
            <AAAFoodHandlers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/google-room-integration"
        element={
          <ProtectedRoute>
            <GoogleRoomIntegration adminStatus={false} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/meet-admin"
        element={
          <ProtectedRoute>
            <GoogleRoomIntegration adminStatus={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/proctorprofile"
        element={
          <ProtectedRoute>
            <ProctorProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/session-history"
        element={
          <ProtectedRoute>
            <SessionHistory />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default Nav;
